
import React,{useEffect,useState, useLayoutEffect} from 'react'
import {Helmet} from "react-helmet";
import { useLocation } from '@reach/router';
import platform from 'platform';
import { ToastContainer, toast } from 'react-toastify';
import  {getsessionid} from '../../../service/trackingService'
// import {getCategories,getBrands } from "../../../service/myProductService";
import 'react-toastify/dist/ReactToastify.css';
import {isMobile} from 'react-device-detect';
import {Home,Redirect} from "../../../utils/constant";
// import { Script } from "gatsby";
import "./layoutmobile.css";


function ServerComponent({serverData, uri}){
    const handleClick=(_uri)=>{
        window.location.href = _uri;
    }
    return(
        <div className="row mgt-10 list-menu mgx-0 pdb-5">
            <div className="col-3 menu-item mgt-5">
                <div className='row' onClick={()=>handleClick('/')}>
                    <div className='col-12'><img src={uri === '/' || uri === '' ? ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_trang_chu.png"):("https://bibomartcdn.multicdn.top/images/2025/1/15/0/origin/ic_bot_home.png")} alt="icon"/></div>
                    <div className='col-12'><span>Trang chủ</span></div>
                </div>
            </div>
            <div className="col-3 menu-item mgt-5">
            <div className='row' onClick={()=>handleClick('/san-pham.html')}>
                    <div className='col-12'> <img src={uri === 'san-pham' || uri === 'danh-muc' || uri === 'danh-sach-san-pham' ?("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_san_pham.png"):("https://bibomartcdn.multicdn.top/images/2025/1/15/0/origin/ic_bot_cat.png")} alt="icon"/></div>
                    <div className='col-12'><span>Danh mục</span></div>
                </div>
                
            </div>
            <div className="col-3 menu-item mgt-5">
            <div className='row' onClick={()=>handleClick('/dac-quyen.html')}>
                    <div className='col-12'> <img src={uri === 'dac-quyen' ?("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_dac_quyen.png"):("https://bibomartcdn.multicdn.top/images/2025/1/15/0/origin/ic_bot_dacquyen.png")} alt="icon"/></div>
                    <div className='col-12'><span>Đặc quyền</span></div>
                </div>
            </div>
            <div className="col-3 menu-item mgt-5">
            <div className='row' onClick={()=>handleClick('/account/manager.html')}>
                    <div className='col-12'><img src={uri === 'accountmanager' ?("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_account.png"):("https://bibomartcdn.multicdn.top/images/2025/1/15/0/origin/ic_bot_profile.png")} alt="icon"/></div>
                    <div className='col-12'><span >Tài khoản</span></div>
                </div>
            </div>
        </div>
    )
  }


const Layoutmobile = ({ children }) => {
    const locationlink = useLocation();
    
    const _path = locationlink.pathname;
    if(Home.includes(_path) === true){
        window.location.href = '/';
    }

    for (var key in Redirect){
        if(key === _path){
            window.location.href = Redirect[key];
        }
    }  
    // console.log = () => {}
    // console.error = () => {}
    // console.debug = () => {}
    const [googlerobots, setGooglerobots] = useState();
    const [robots, setRobots] = useState();
    let uri = locationlink.pathname.replace('.html','').replaceAll('/','');

    useEffect(()=>{
        if(isMobile === false){
            if(locationlink.pathname.includes('mobile/trang-chu.html') === true){
                window.location.href ='/';
                return;
            }
            if(locationlink.pathname.includes('mobile/trang-chu.html') === false){
                var url = locationlink.href;
                var uriLink = url.replace(locationlink.host+'/mobile', locationlink.host);
                window.location.href =uriLink ;
                return;
            }
        }
         const searchParams = new URLSearchParams(locationlink.search);
         let _userReferral = searchParams.get("userReferral")??''; 
         if(searchParams.has("userReferral") && searchParams.get("userReferral") !== undefined){
             window.localStorage.setItem('userReferral', _userReferral);
         }
         let _idShare = searchParams.get("idShare")??''; 
         if(searchParams.has("idShare")  && searchParams.get("idShare") !== undefined){
             window.localStorage.setItem('idShare', _idShare);
         }
        const _session_id = window.localStorage.getItem('sessionId');
        if (_session_id === '') {
            try{
                getsessionid().then((response)=>{
                    if(+response.status === 200){
                        window.localStorage.setItem('sessionId',response?.message);
                    }
                });
            }catch(e){console.log(e);}
        }
        if(locationlink.pathname.includes('/') === true){
            setGooglerobots('index, follow');
            setRobots('index, follow, noodp, noydir');
        }else{
            // setRobots('noindex, nofollow');
            // setGooglerobots('noindex, nofollow');
            setGooglerobots('index, follow');
            setRobots('index, follow, noodp, noydir');
        }
        // getDataCategories();
        // loadDataBrand();
    },[googlerobots]);    
    const handleClick=(_uri)=>{
        window.location.href = _uri;
    }
    // useLayoutEffect(() => {
    //   if (typeof window !== 'undefined') {
    //     const el = document.querySelector('.modal-open');
    //     if (el) {
    //       el.style.overflow = 'unset';
    //     }
    //   }
    // }, []);
let fontStyle =`@font-face {
    font-family: SF Pro Rounded;
    src: url('/static/fonts/SF-Pro-Rounded-Regular.woff') format('woff'),
    url('/static/fonts/SF-Pro-Rounded-Regular.woff2') format('woff2'),
    url('/static/fonts/SF-Pro-Rounded-Regular.svg#SF-Pro-Rounded-Regular') format('svg'),
    url('/static/fonts/SF-Pro-Rounded-Regular.eot'),
    url('/static/fonts/SF-Pro-Rounded-Regular.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/SF-Pro-Rounded-Regular.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    }`;        
return (
    <>
    <Helmet defer={false}>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <meta name="robots" content={robots}/>
    <meta name="googlebot" content={googlerobots}/>
    <link rel="stylesheet" href="/../static/css/style_app.min.css" type="text/css" />
    {/* <link rel="stylesheet" href="/../static/css/style_app.css" type="text/css" /> */}
    <link rel="stylesheet" href="/../static/css/carosel.css" type="text/css" />
    <noscript>{`<link rel="stylesheet" href="/../static/css/style_app.min.css"/>`}</noscript>
    <link rel="stylesheet" href="/../static/vendor/soconfig/css/ratchet/ratchet-add.css"/>
    <script src="/../js/datetimepicker/moment/moment-with-locales.min.js"></script>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css"/>
    <link rel="stylesheet" href="/../static/vendor/fontawesome/css/all.css"/>
    <script href="/../static/bootstrap/js/bootstrap.min.js"></script>
    <script href="/js/touchstart.js"></script>
        <style>
                {fontStyle}
        </style>
        <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-W4DFJPRZ');`}
        </script>
        <link rel="icon" type="image/x-icon" href="/images/favicon.png" />
        <script type="application/ld+json">
        {`{
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "bibomart",
            "url": "https://bibomart.com.vn/",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://bibomart.com.vn/ket-qua-tim-kiem.html?{search_term_string}",
                "query-input": "required name=search_term_string"
                }
        }`}
    </script>
    <body className="so-demos-ready loaded" id='mobile'/>
    <noscript>{`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W4DFJPRZ" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}</noscript>
    </Helmet>
    <div id="wrapper" className={platform.name === "Safari" ? ("wrapper-full banners-effect-1 safari"):("wrapper-full banners-effect-1")}>
        <div className="so-pre-loader no-pre-loader">
                <div className="so-loader-line" id="line-load"></div>
        </div>
        <div id="content" className="page-builder-ltr">
                {children}
        </div>

        <div className='clearfix'></div>
        <div className='height-w'></div>
        <ServerComponent serverData={null} uri={uri}/>
    </div>
    <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        />
    </>
  )
}
export default Layoutmobile
// export async function getServerData() {
//     let Footer = {
//   };
//     try {
//       return {
//         props: {Footer}
//   }
//   } catch (error) {
//     return {
//       status: 500,
//       headers: {},
//       props: {}
//     }
//   }
//   }